import { useMemo, useRef } from "react";

let embodiedFieldIdSeq = 0;

/** Parse a user-typed emissions/storage string; commas stripped. */
export function parseEmbodiedNum(v) {
    const n = parseFloat(String(v).replace(/,/g, ""));
    return Number.isFinite(n) ? n : null;
}

/**
 * Stable id for citation inputs (autocomplete/password-manager hints).
 * Prefix should distinguish framing vs window vs layer row.
 */
export function useEmbodiedFieldId(prefix) {
    const idRef = useRef(null);
    if (idRef.current === null) {
        idRef.current = `${prefix}-${++embodiedFieldIdSeq}`;
    }
    return idRef.current;
}

/** Shared keyboard/mouse handlers for expandable grade cells (framing + whole-window). */
export function useExpandableGradeCellHandlers(setExpanded) {
    return useMemo(
        () => ({
            onClick: (e) => {
                e.stopPropagation();
                setExpanded((v) => !v);
            },
            onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setExpanded((v) => !v);
                }
            },
            role: "button",
            tabIndex: 0,
        }),
        [setExpanded]
    );
}
